import request from 'meinian-package/src/utils/request'
import SparkMD5 from 'spark-md5'

const CDN_HOST = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/'
const CDN_DIR = 'ins-selected/'
const GET_TOKEN_API = '/upload/get-oss-upload-token'

export const UPLOAD_ERROR_TYPE = { TYPE_ERROR: 1, SIZE_ERROR: 2, UPLOAD_ERROR: 3, COUNT_ERROR: 4 }
function unionid({ mime, customDir }) {
  return `${customDir || CDN_DIR + new Date().getTime()}_${Math.random().toString(32).substr(2, 10)}${mime || '.png'}`
}

export function getExtensionFromBase64(base64) {
  const re = /data:image\/(?<ext>.*?);base64,.*/
  const res = re.exec(base64)
  if (res) {
    return res.groups.ext
  }
}

export const uploadToOSS = async (file, customDir, onUploadProgress, onError, mime) => {
  const spark = new SparkMD5()
  spark.append(file)
  const hashMD5 = spark.end()
  const result = await request.get(GET_TOKEN_API, { params: { dir: customDir || CDN_DIR } })
  const res = result.sign
  const key = unionid({ customDir, mime })
  try {
    await request.formdata(res.host, {
      OSSAccessKeyId: res.accessid,
      signature: res.signature,
      policy: res.policy,
      success_action_status: 200,
      key,
      file
    }, e => onUploadProgress?.(e, key, file))
    const url = CDN_HOST + key
    return { url, filename: file.name, hashMD5 }
  } catch (error) {
    onError?.(UPLOAD_ERROR_TYPE.UPLOAD_ERROR, file)
  }
}

export function base64ToFile(dataUrl, name = new Date().getTime()) {
  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1]); let n = bstr.length; const
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${name}.jpg`, { type: mime })
}

export const getImageBase64 = (image) => {
  const canvas = document.createElement('canvas')
  canvas.width = image.width
  canvas.height = image.height
  const ctx = canvas.getContext('2d')
  ctx.drawImage(image, 0, 0, image.width, image.height)
  // 获取图片后缀名
  const extension = image.src
    .substring(image.src.lastIndexOf('.') + 1)
    .toLowerCase()
  // 某些图片 url 可能没有后缀名，默认是 png
  return canvas.toDataURL(`image/${extension}`, 1)
}
